import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { RootState } from "../../app/store";
import fetchAPI from "../../common/fetchAPI";

interface attachmentStateClass {
    isLoading: boolean;
    status: 'idle' | 'loading' | 'failed';
    attachmentList: Array<any>;
    selectedRecord: any;
    isReload: boolean;
    employeeInformation: Array<any>;
    isCanvasLoader:boolean;
}

const initialState: attachmentStateClass = {
    isLoading: false,
    status: 'idle',
    attachmentList: [],
    selectedRecord: {},
    isReload: false,
    employeeInformation: [],
    isCanvasLoader:true
}

interface IThunkApi {
    state: {
        attachment: attachmentStateClass
    }
}

export const addAttachment = createAsyncThunk
    <any, any, IThunkApi>
    (
        'attachments/postAttachment',
        async (args, thunkApi) => {
            const { Id, formData, IsEdit, tempAttachmentId, AccountAttachmentTypeId } = args;
            let response: any = "";
            let ControllerName = "";
            if (AccountAttachmentTypeId === 1) {
                ControllerName = 'ExpenseSheets'
            }
            else if (AccountAttachmentTypeId === 2) {
                ControllerName = 'Timesheets';
            }
            else if (AccountAttachmentTypeId === 3) {
                ControllerName = 'TimeOffs';
            }
            else if (AccountAttachmentTypeId === 4) {
                ControllerName = 'Projects';
            }
            else if (AccountAttachmentTypeId === 5) {
                ControllerName = 'Tasks';
            }
            if (!IsEdit) {
                if (Id !== undefined && Id !== null && Id !== '' && Id !== '00000000-0000-0000-0000-000000000000' && Id != 0) {
                    //response = await fetchAPI(`api/V2/TimeOffs/SaveAttachments?Id=${Id}&AttachmentId=${tempAttachmentId}&isEdit=${IsEdit}`,'POST',formData,true,'cce1c985-3054-43d2-b262-0731a14f3ca8',true);
                     response = await fetchAPI(`api/V2/${ControllerName}/SaveAttachments?Id=${Id}&AttachmentId=${tempAttachmentId}&isEdit=${IsEdit}&isFromReact=true`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
                }
                else {
                    response = await fetchAPI(`api/V2/${ControllerName}/SaveAttachments?isEdit=${IsEdit}&isFromReact=true`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
                }
            }
            else {
                response = await fetchAPI(`api/V2/${ControllerName}/SaveAttachments?Id=${Id}&isEdit=${IsEdit}&isFromReact=true`, 'POST', formData, true, 'cce1c985-3054-43d2-b262-0731a14f3ca8', true);
            }
            const json = await response.json();
            return json;
        }
    )


export const getAttachmentsAsync = createAsyncThunk
    <any, any, IThunkApi>
    (
        'attachments/getAttachment',
        async (args, thunkApi) => {
            const { Id, ControllerName } = args;
            const response = await fetchAPI(`api/V2/${ControllerName}/GetAttachments?Id=${Id}&attachmentUrl=`, 'GET', '', true, 'cce1c985-3054-43d2-b262-0731a14f3ca8');
            const json = await response.json();
            return json
        }

    )

export const deleteAttachments = createAsyncThunk
    <any, any, IThunkApi>
    (
        'attachments/deleteAttachment',
        async (args, thunkApi) => {
            const { AccountAttachmentId, ControllerName } = args
            const response = await fetchAPI(`api/V2/${ControllerName}/Attachment?Id=${AccountAttachmentId}`, 'DELETE', '', true, 'cce1c985-3054-43d2-b262-0731a14f3ca8');
            const json = await response.json();
            return json
        }
    )

export const deleteTempAttachment = createAsyncThunk
    <any, any, IThunkApi>
    (
        'attachments/deleteTempAttachment',
        async (args, thunkApi) => {
            const { AccountAttachmentId, AttachmentName } = args
            const response = await fetchAPI(`api/V2/TimeOffs/TempAttachment?Id=${AccountAttachmentId}&AttachmentName=${AttachmentName}`, 'DELETE', '', true, 'cce1c985-3054-43d2-b262-0731a14f3ca8');
            const json = await response.json();
            return json
        }
    )

export const attachmentSlice = createSlice({
    name: 'attachment',
    initialState,
    reducers: {
        resetSelectedRecordObjectInState: (state) => {
            state.selectedRecord = {};
        },
        resetAttachmentList:(state)=>{
            state.attachmentList = [];
        }
    },
    extraReducers: (builder) => {
        builder
            .addCase(addAttachment.pending, state => {
                state.status = 'loading';
            }).addCase(addAttachment.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            }).addCase(addAttachment.rejected, (state) => {
                state.status = 'failed';
            })
            .addCase(getAttachmentsAsync.pending, state => {
                state.status = 'loading';
                state.isCanvasLoader = true;
            }).addCase(getAttachmentsAsync.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.attachmentList = [];
                state.attachmentList = payload.AttachementInformation ? payload.AttachementInformation : [];
                state.employeeInformation = payload.EmployeeInformation;
                state.isReload = false;
                state.isCanvasLoader = false;
            }).addCase(getAttachmentsAsync.rejected, (state) => {
                state.status = 'failed';
                state.attachmentList = [];
                state.isCanvasLoader = true;
            })
            .addCase(deleteAttachments.pending, state => {
                state.status = 'loading';
            }).addCase(deleteAttachments.fulfilled, (state, { payload }) => {
                state.status = 'idle';
                state.isReload = true;
            }).addCase(deleteAttachments.rejected, (state) => {
                state.status = 'failed';
            })
    }
})

export const { resetSelectedRecordObjectInState, resetAttachmentList } = attachmentSlice.actions;
export const attachmentState = (state: RootState) => state.attachment
export default attachmentSlice.reducer;